// tslint:disable max-line-length
import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import Clamp from 'react-multiline-clamp';
import { themePalette } from '../../utils/theme-palette';
import { getItem } from '../../utils/localStorage';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 18px 11px;
  border-radius: 6px;
  box-shadow: 0px 2px 5px 1px rgb(0 0 0 / 13%);
  -webkit-box-shadow: 0px 2px 5px 1px rgb(0 0 0 / 13%);
  -moz-box-shadow: 0px 2px 5px 1px rgb(0 0 0 / 13%);
`;

const ArticleImage = styled.div`
  width: 100%;
  height: 128px;
  max-height: 128px;
  img {
    object-fit: cover;
    object-position: center;
    width: 100%;
    height: 128px;
  }
`;

const ArticleInformation = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 10px;
  row-gap: 5px;
`;

const ArticleTitle = styled.span`
  font-family: 'Source Sans Pro', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 19px;
  color: #031c38;
`;

const ArticleSubtitle = styled.span`
  color: ${themePalette.lighgreen};
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  text-align: left;
`;

const LearningHubCard = ({ itemData }) => {
  const navigate = useNavigate();
  const userData = getItem('user');

  if (
    !userData ||
    !userData.user ||
    !userData.user.brands ||
    !userData.user.brands.length ||
    userData.user.brands[0].hotels.length <= 0
  ) {
    if (itemData.title === 'Brand Standards') {
      return <></>;
    }
  }

  return (
    <Wrapper
      onClick={() =>
        navigate(itemData.navigate, {
          state: itemData.state,
        })
      }
    >
      <ArticleImage>
        <img src={itemData.media} />
      </ArticleImage>
      <ArticleInformation>
        <Clamp withTooltip={true} lines={1}>
          <ArticleTitle>{itemData.title}</ArticleTitle>
        </Clamp>
        <ArticleSubtitle>{itemData.subtitle}</ArticleSubtitle>
      </ArticleInformation>
    </Wrapper>
  );
};

export default LearningHubCard;
